export function setServiceDetailTable () {
  const serviceDetailTableCols = [
    {
      title: '商品图片',
      dataIndex: 'image',
      key: 'image',
      width: 120,
      ellipsis: true,
      scopedSlots: { customRender: 'imageList' },
    },
    {
      title: '商品编码',
      dataIndex: 'goodsCode',
      key: 'goodsCode',
      width: 120,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '商品名称',
      dataIndex: 'goodsName',
      key: 'goodsName',
      width: 160,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '品牌名称',
      dataIndex: 'brandName',
      key: 'brandName',
      width: 160,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '规格',
      dataIndex: 'specification',
      key: 'specification',
      width: 100,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '型号',
      dataIndex: 'model',
      key: 'model',
      width: 100,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '生产商',
      dataIndex: 'producer',
      key: 'producer',
      width: 160,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '厂家编码',
      dataIndex: 'factoryCode',
      key: 'factoryCode',
      width: 100,
      ellipsis: true,
      customRender: text => {
        return text || '--';
      },
    },
    {
      title: '销售单价',
      dataIndex: 'unitPrice',
      key: 'unitPrice',
      width: 100,
      ellipsis: true,
      customRender: text => {
        return text === '' || text === null || text === undefined ? '--' : text.toLocaleString('en-US', { minimumFractionDigits: 2 });
      },
    },
    {
      title: '是否医疗件',
      dataIndex: 'isMedichair',
      key: 'isMedichair',
      width: 100,
      ellipsis: true,
      customRender: text => {
        return text === 1 ? '是' : '否';
      },
    },
  ];

  return serviceDetailTableCols;
}
